export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#E32013', '#E32013'],
        home_question: ['#E32013', '#E32013'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '25px',
        photo: '0rem',
        textField: '25px !important',
    },
    shadows : {
        default: 'none',
        home_question: '0px 2px 5px #6b6b6b'
    },

    agendaStyle : {
        headerColor: '#E32013',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '25px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: 'rgba(227,32,19,0.5)',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#E32013',
        headerBkgColor: '#E32013',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#d97872'
    },

    primary: '#E32013',
    secondary: '#263238',
    accent: '#E32013',
    text: '#eceff1',
    buttonText: {
        home_question: '#fff',
        default: '#fff'
    },
    background:"radial-gradient(#ECECEC, #E5E5E5, #D4D4D4, #B8B8B8, #979797)",

    homeQuestionIcon: false,

    poll:{
        default:"#ECECEC",
        answered:"#FBE058",
        correct: '#53CE76',
        wrong: '#9E0000'
    },
    pollBorder: {
        default:"#ECECEC",
        answered:"#FBE058",
        correct: '#53CE76',
        wrong: '#9E0000'
    },
    pollTextColor: {
        default:"#000",
        answered:"#000",
        correct: '#000',
        wrong: '#000'
    }
}